import {convertCoordinates} from '@/api/util-coordinates';

class PublicWorkApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    id,
    name,
    description,
    access,
    town,
    province,
    category,
    c1,
    c2,
    c3,
    c4,
    c5,
    c6,
    cx,
    cy,
    // visible,
  }) {
    return {
      id,
      name,
      description,
      access,
      town,
      province,
      category,
      c1,
      c2,
      c3,
      c4,
      c5,
      c6,
      coordinates: convertCoordinates(cx, cy),
      visible: false,
    };
  }
}

export default PublicWorkApiResponseModel;
